import { Image } from 'expo-image';
import { useMemo, useState } from 'react';
import {
  View, Text, StyleSheet, FlatList, Pressable, Dimensions,
  TouchableOpacity, ActivityIndicator
} from 'react-native';
import Entypo from '@expo/vector-icons/Entypo';
import { NativeStackScreenProps } from '@react-navigation/native-stack';
import Fontisto from '@expo/vector-icons/Fontisto';

import { PayAPI } from '../data/payApi';
import { Button, Modal, Toast } from 'native-base';
import { RootStackParamList } from '../navigation';
import { useTypedSelector } from '../redux/store';

let { width } = Dimensions.get('window');
if(width > 460){ width = 460; }
const COLUMN_WIDTH = width / 2 - 20;

type Props = NativeStackScreenProps<RootStackParamList, 'GemPay'>;

export default function GemPayScreen({
  navigation, route
}: Props) {
  const cacheData = useMemo(()=>[
    { id: "1", name: "10,000 Coin", price: "$10.00", pay_key: "price_1RERENK9oh0lFlzBugEU8z6V" },
    { id: "2", name: "55,000 Coin", price: "$50.00 (10% More)", pay_key: "price_1RERFeK9oh0lFlzBpJm1u7GM" },
    { id: "3", name: "120,000 Coin", price: "$100.00 (20% More)", pay_key: "price_1RERGgK9oh0lFlzBZI0I3BGX" },
  ],[]);
  const [checkoutPlan, setCheckoutPlan] = useState(cacheData[2]);
  const [payLoad, setPayLoad] = useState(false);
  const userCurrent = useTypedSelector((state) => state.userCurrent);

  const payChange = async ()=>{
    if(payLoad) return;
    setPayLoad(true);
    let res = await PayAPI.getPlanUrl(checkoutPlan.pay_key, "payment");
    if(res && res.url){
      window.location.href = res.url;
    }else{
      setPayLoad(false);
      Toast.show({
        title: "Pay failed",
        placement: "top",
        bgColor: "rgba(255,0,0,0.4)" 
      })
    }
    // TODO: pay
  }

  const renderItem = ({
    item
  }:{
    item: typeof cacheData[number]
  })=>(
    <Pressable
      onPress={()=> setCheckoutPlan(item) }>
      <View style={{
        gap: 10, alignItems: "center", width: COLUMN_WIDTH,
        padding: 12, margin: 5, position: "relative",
        borderWidth: 2,
        borderRadius: 12,
        borderColor: checkoutPlan.pay_key === item.pay_key ? "rgb(179,88,251)" : "transparent",
        backgroundColor: "#24263B",
      }}>
        {item.id === "3" && (
          <View style={{
            position: "absolute", top: -8, right: 14,
            height: 16, paddingLeft: 10, paddingRight: 10,
            alignItems: "center", borderRadius: 10,
            backgroundImage: "linear-gradient(to right, rgb(148,9,255), rgb(173,8,255))",
          }}>
            <Text style={{
              fontSize: 12, color: "#FFFFFF", fontWeight: "bold"
            }}>
              BEST OFFER
            </Text>
          </View>
        )}
        <Text style={{ fontSize: 14, color: "#FFFFFF", fontWeight: "bold" }}>
          {item.name}
        </Text>
        <Text style={{ fontSize: 13, color: "#FFFFFF", fontWeight: "bold" }}>
          {item.price}
        </Text>
      </View>
    </Pressable>
  )

  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <Button style={{
          backgroundColor: "rgba(0,0,0,0.5)",
          borderRadius: 100, padding: 4,
        }} onPress={()=> navigation.goBack() }>
          <Entypo name="chevron-left" size={24} color="#FFFFFF" />
        </Button>
        <Text style={styles.appName}>Purchase coins</Text>
        <View style={styles.nav_right_ctx}>
          <Fontisto name="database" size={12} color="#FFFFFF" />
          <Text style={{ color: '#FFFFFF', fontSize: 14 }}>{userCurrent.coins}</Text>
        </View>
      </View>
      <View style={{ alignItems: "center", marginTop: 20 }}>
        <Image style={{ width: 80, height: 80 }}
          source={ require('../assets/material/more-coin.png') }
        />
        <View style={{
          flexDirection: "row", gap: 10, alignItems: "center",
          marginTop: 4,
        }}>
          <Text style={{ color: "#FFFFFF", fontSize: 24, fontWeight: "bold"}}>
            {userCurrent.coins}
          </Text>
        </View>
      </View>
      <FlatList
        data={cacheData}
        renderItem={renderItem}
        numColumns={2}
        keyExtractor={(item)=> item.name}
        style={{ marginTop: 20, padding: 10, flexGrow: 0 }}
      />
      <View style={{ padding: 15, paddingTop: 0 }}>
        <TouchableOpacity style={{
          height: 50, borderRadius: 10, paddingLeft: 10, paddingRight: 10,
          backgroundImage: "linear-gradient(to bottom, rgb(148,9,255), rgb(173,8,255))",
          flexDirection: "row", gap: 10, marginBottom: 6,
          alignItems: "center", justifyContent: "center"
        }} onPress={payChange}>
          <Text style={{
            fontSize: 18, color: "#FFFFFF", fontWeight: "700"
          }}>
            Pay {checkoutPlan.price}
          </Text>
        </TouchableOpacity>
      </View>
      <Modal isOpen={payLoad} size="full" bg="black.700:alpha.70"
        justifyContent="center" alignItems="center"
        style={{
          width: "100%", maxWidth: 460,
          marginLeft: "auto", marginRight: "auto",
        }}>
        <ActivityIndicator size="large" color="#FFFFFF" />
      </Modal>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#191B2C',
  },
  header: {
    flexDirection: 'row',
    paddingLeft: 6,
    paddingRight: 6,
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 50,
    backgroundColor: 'rgb(25,27,44)',
  },
  appName: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#FFFFFF',
  },
  nav_right_ctx: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    borderRadius: 20,
    padding: 2,
    paddingLeft: 12,
    paddingRight: 12,
    borderWidth: 1,
    borderColor: "#007AFF",
    borderStyle: "solid",
    backgroundColor: "rgba(0,0,0,0.5)"
  }
});